import {
  ARTIFACT_LABEL,
  ARTIFACT_LABELS,
  getBreadcrumb,
  removeHTMLTags,
} from '@jusbrasil-web/docview/core'
import { organization, siteNavigation, website } from '@jusbrasil-web/shared-utils-seo'

import { ArticleNewsMetaTags_DocumentFragment } from './__generated__/article-news-meta-tags.graphql'

const MAX_DESCRIPTION = 116

export class ArticleNewsSeoMetadata {
  private readonly document
  private readonly artifactLabel

  constructor(document: ArticleNewsMetaTags_DocumentFragment) {
    this.document = document
    this.artifactLabel =
      document.artifact === ARTIFACT_LABEL.ARTIGO
        ? ARTIFACT_LABELS.ARTIGO
        : ARTIFACT_LABELS.NOTICIAS
  }

  private getDescription() {
    const { text, subtitle, description: docDescription, artifact } = this.document
    const artifactLabelMap: Record<string, string> = {
      ARTIGO: 'o artigo',
      NOTICIAS: 'a notícia',
    }

    const description = removeHTMLTags(text || subtitle || docDescription || '').substring(
      0,
      MAX_DESCRIPTION
    )

    return `${description}... Clique para ver ${artifactLabelMap[artifact]} na íntegra.`
  }

  private getStructuredDataItems() {
    const { title, url, meta } = this.document

    return {
      article: {
        ...meta,
        alternativeHeadline: meta?.headline
          ? `${meta?.headline} em ${this.artifactLabel.pluralLabel.toLowerCase()}`
          : null,
        alternateName: meta?.headline || null,
      },
      breadcrumb: getBreadcrumb({
        url: url || '',
        title: title || '',
        artifactLabel: this.artifactLabel,
      }),
    }
  }

  private buildSeoMetadata() {
    const { title, noIndex } = this.document

    const description = this.getDescription()
    const { breadcrumb, article } = this.getStructuredDataItems()

    return {
      title: `${title || ''} | Jusbrasil`,
      description,
      keywords: [],
      structuredData: {
        '@context': 'https://schema.org',
        '@graph': [organization, website, siteNavigation, breadcrumb, article].filter(Boolean),
      },
      noIndex,
    }
  }

  getSeoMetadata() {
    return this.buildSeoMetadata()
  }
}
